export default "__VITE_ASSET__DkrhEy3O__"